/**
 * Enums para CategoriaTorneio
 */

export enum ModeloDisputa {
  ELIMINACAO_SIMPLES = 'ELIMINACAO_SIMPLES',
  ELIMINACAO_DUPLA = 'ELIMINACAO_DUPLA',
  GRUPOS_ELIMINACAO = 'GRUPOS_ELIMINACAO',
  GRUPO_UNICO = 'GRUPO_UNICO',
  LIGA = 'LIGA',
  SUICO = 'SUICO',
  REI_RAINHA = 'REI_RAINHA',
  SUPER_8 = 'SUPER_8',
}

export enum TipoPontuacao {
  SETSGAMES = 'SETSGAMES',
  SETSPONTOS = 'SETSPONTOS',
}

export enum TipoGrupoChave {
  GRUPO = 'GRUPO',
  CHAVE = 'CHAVE',
  GRUPO_CHAVE = 'GRUPO-CHAVE',
}

export enum StatusCategoriaTorneio {
  AGENDADA = 'AGENDADA',
  EM_ANDAMENTO = 'EM_ANDAMENTO',
  ENCERRADA = 'ENCERRADA',
  INSCRICAO_ABERTA = 'INSCRICAO_ABERTA',
  INSCRICAO_ENCERRADA = 'INSCRICAO_ENCERRADA',
}

export enum GeneroCategoria {
  MASCULINO = 'MASCULINO',
  FEMININO = 'FEMININO',
  MISTO = 'MISTO',
  OUTRO = 'OUTRO',
}
